<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.editStudentInvoice')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button :storeLocal="true"></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Form -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.editStudentInvoice')}}</div>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="updateInvoice()"
                                :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="updateInvoice(true)"
                                :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                             <button class="btn btn-danger" @click="generate('pdf')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                            </button>
                            <button class="btn btn-primary" @click="generate('word')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.invoice.tabGeneral')" active>
                                <div class="row">
                                    <div class="col-md-12">
                                        <!-- <div class="row"> -->

                                        <div class="form-group">
                                            <label for="InvoiceNumberField">{{$t('form.invoice.invoiceNumber')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="InvoiceNumberField" type="text" v-model="invoice.InvoiceNumber"
                                                class="form-control" required="required" disabled>
                                        </div>

                                        <!-- </div> -->
                                      <div class="row">
                                          <div class="col-md-6">
                                           <div class="form-group">
                                            <label for="StudentNameField">{{$t('form.invoice.student')}}<span
                                                    class="text-danger">*</span></label>
                                            <ul class="list-group m-0">
                                                <div class="input-group">
                                                    <input type="hidden" v-model="studentId">
                                                    <input id="StudentNameField" type="text" class="form-control"
                                                        v-model.trim="$v.studentName.$model"
                                                        :class="{ 'is-invalid': $v.studentName.$error }" disabled>
                                                    <!-- <div class="input-group-append">
                                                        <span class="input-group-text remove_btn" v-on:click="clear()">
                                                            <i class="fa fa-times"></i></span>
                                                    </div> -->

                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.studentName.required">
                                                    {{$t('form.validation.required')}}</div>

                                                <!-- <li class="list-group-item" v-for="(student,index) in students"
                                                    v-bind:key='index'>
                                                    <a @click="setStudentName(student)">
                                                        {{student.StudentNumber}} - {{student.FirstName}} {{student.LastName}}
                                                    </a>
                                                </li> -->

                                            </ul>
                                        </div>
                                       </div>
                                       <div class="col-md-6" v-if="!readonly">
                                        <div class="form-group">
                                            <label>{{$t('form.invoice.program')}}<span
                                                    class="text-danger">*</span></label>
                                            <v-select @input="programSelected" label="FullTitle" :options="programs"
                                                v-model="program" :reduce="programs => programs"
                                                :class="{ 'is-invalid': $v.program.FullTitle.$error }" :disabled="true"></v-select>
                                              <div class="invalid-feedback" v-if="!$v.program.FullTitle.required">
                                            {{$t('form.validation.required')}}</div>
                                        </div>

                                        <div class="form-group" v-if="program.BillingCycle == 'course' && course && invoice.PaymentPlan != 'Full Payment'">
                                            <label>{{$t('form.invoice.course')}}</label>
                                            <v-select label="FullTitle" @input="selectedCourse" :options="courses"
                                                v-model.trim="course" :reduce="courses => courses">
                                            </v-select>
                                        </div>

                                        <div class="form-group" v-else-if="program.BillingCycle == 'term' && term && invoice.PaymentPlan != 'Full Payment'">
                                            <label>{{$t('form.invoice.terms')}}</label>
                                            <v-select :options="semesters" @input="selectedSemester" v-model.trim="term"
                                                :reduce="semesters => semesters"></v-select>
                                        </div>

                                        <!-- <label>{{$t('form.invoice.tuitionPurpose')}}</label>
                                        <div class="form-group">
                                            <label for="MbaCourses">{{$t('form.invoice.MBACourses')}}</label>
                                            <v-select label="FullName" :options="mbaCourse" v-model="value"
                                                @input="setMBACourseTitle(value); mbaCoursePurpose()"
                                                :reduce="mbaCourse => mbaCourse.ProgramTitle">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="DateField">{{$t('form.invoice.date')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="mbaCourseDate"
                                                @change="mbaCoursePurpose()" valueType="format" :format="dateFormat">
                                            </date-picker>
                                        </div> -->
                                    </div>
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>{{$t('form.invoice.mailAddress')}}</label><br>
                                            <b-form-radio name="mail" v-model="invoice.MailAddress" value="1">
                                                {{$t('form.invoice.personalAddress')}}
                                            </b-form-radio>
                                            
                                            <b-form-radio name="mail" v-model="invoice.MailAddress" value="2" :disabled="isRadioDisabled" v-b-tooltip.hover.top :title="businessTooltip" style="position: relative; display: inline-block;">
                                                {{$t('form.invoice.businessAddress')}}
                                            </b-form-radio>
                                            
                                        </div>

                                        <div v-if="invoice.CreatedBy !== 'PaymentPlan'" class="form-group">
                                            <label>
                                                <input type="checkbox" id="acceptance-fee"
                                                v-model="invoice.acceptanceFee" /> {{$t('form.invoice.acceptanceFee')}}
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>{{$t('form.invoice.invoicePurpose')}}<span class="text-danger">*</span></label>
                                            <v-select :options="invoicePurposes"
                                                v-model="InvoicePurpose"
                                                :reduce="invoicePurposes => invoicePurposes">
                                            </v-select>

                                            <div class="d-flex justify-content-between mt-2" v-if="!readonly">
                                                <b-form-input v-model="newPurpose"
                                                    :placeholder="$t('form.invoice.newPurpose')"></b-form-input>
                                                <b-button class="ml-2" variant="light" @click="addPurpose">
                                                    {{$t('button.save')}}</b-button>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="AdditionalInvoiceInfo">{{$t('form.invoice.InvoiceInfo')}}</label>
                                            <input id="AdditionalInvoiceInfo" data-toggle="tooltip" title="This info will be shown on the invoice below the address." type="text" v-model="invoice.InvoiceInfo" class="form-control">
                                            <div class="invalid-feedback custom-validate" v-if="invalidInvoiceInfo">
                                                {{$t('form.validation.maxCharacters')}}</div>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.invoice.amount')}}<span class="text-danger">*</span></label>
                                            <input v-model="invoice.Amount" class="form-control" :disabled="disableAmount"  v-on:keydown="applyDiscount" v-on:blur="applyDiscount">

                                            <template v-if="(invoice.Discount > 0 || invoice.FullPaymentDiscountedAmount)&& !invoice.acceptanceFee">
                                                <div class="d-flex" style="height:20px;">
                                                    <p class="text-muted" v-if="invoice.Remarks && !invoice.Separately">
                                                    {{ invoice.Remarks }}</p>
                                                    <p class="text-muted" v-else-if=" !invoice.Separately">
                                                    {{$t('form.invoice.globalDiscountInfo', {discount: invoice.Discount})}}</p>
                                                    &nbsp;
                                                    <p class="text-muted" v-if="invoice.FullPaymentDiscountedAmount">
                                                    {{$t('form.invoice.fullPaymentDiscountInfo', {fullPaymentDiscount: fullPaymentDiscount})}}</p>

                                                </div>
                                            </template>
                                        </div>

                                        <!-- Disabled temproarily for phase 3 -->
                                        <!-- <div v-if="invoice.PaymentPlanReductionLogic && invoice.DiscountedAmount > 0" class="form-group">
                                        <label v-if="invoice.PaymentPlanReductionLogic">
                                            <input v-if="invoice.CreatedBy === 'PaymentPlan' && discount > 0 && fullPaymentDiscount > 0" type="checkbox"  @change="applyPaymentPlanReduction()"
                                            v-model="paymentPlanReduction" /> {{$t('form.invoice.apply_payment_plan_reduction')}}
                                        </label>
                                        </div> -->

                                        <div class="form-group" v-if="invoice.Discount > 0 && invoice.CreatedBy !== 'PaymentPlan' && !invoice.acceptanceFee">
                                            <b-form-checkbox id="excludeScholarshipReduction" v-model="invoice.excludeScholarshipReduction" @change="applyDiscount">
                                                    {{$t('form.invoice.exclude_scholarship_reduction')}}
                                            </b-form-checkbox>
                                        </div>

                                        <div class="form-group" v-if="invoice.Discount > 0 && !invoice.excludeScholarshipReduction && !invoice.acceptanceFee && invoice.AmountAfterDeductibles === null && !invoice.Separately">
                                            <label>{{$t('form.invoice.discountedAmount')}}</label>
                                            <input v-model="invoice.DiscountedAmount" class="form-control" readonly>
                                        </div>


                                        <div class="form-group" v-if="invoice.AmountAfterDeductibles !== null && invoice.InvoicedSeparately == 0">

                                            <label>{{ invoice.Discount > 0 ? $t('form.invoice.amountAfterDeductiblesAndScholarship') : $t('form.invoice.amountAfterDeductibles') }}</label>

                                            <input v-model="invoice.AmountAfterDeductibles" class="form-control" readonly>
                                        </div>
                                        <div class="form-group" v-if="fullPaymentDiscount > 0 &&
                                            (invoice.FullPaymentDiscountedAmount != 0 && invoice.FullPaymentDiscountedAmount != null)">
                                            <label>{{$t('form.invoice.fullDiscountedAmount')}}</label>
                                            <input v-model="invoice.FullPaymentDiscountedAmount" class="form-control" readonly>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.invoice.currency')}} <span
                                                    class="text-danger">*</span></label>
                                            <v-select :options="currencies" v-model.trim="$v.invoice.Currency.$model"
                                                :reduce="currencies => currencies" :key="invoice.Currency">
                                            </v-select>
                                            <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.invoice.invoiceDate')}} <span
                                                    class="text-danger">*</span></label>

                                            <date-picker :lang="lang" class="date-picker" v-model="invoice.InvoiceDate"
                                                valueType="format" :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                            </date-picker>
                                            <div class="invalid-feedback custom-validate" v-if="invalidDate">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.invoice.dueDate')}} <span
                                                    class="text-danger">*</span></label>
                                            <date-picker :lang="lang" class="date-picker" v-model="invoice.DueDate"
                                                valueType="format" :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                            </date-picker>
                                            <div class="invalid-feedback custom-validate" v-if="invalidDue">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                       <div class="form-group">
                                        <label>
                                            <input type="checkbox"  @change="invoicePaid()"
                                                v-model="invoice.Paid" /> {{$t('form.invoice.paid')}}
                                        </label>
                                     </div>
                                        <div class="form-group">
                                            <label>{{$t('form.invoice.paymentDate')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="invoice.PaymentDate"
                                                valueType="format" :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                            </date-picker>
                                        </div>
                                        <div class="form-group">
                                            <b-form-checkbox id="send-invoice" v-model="invoice.SendInvoice"
                                            :disabled="readOnlySend">
                                                {{$t('form.invoice.sendInvoice')}}
                                            </b-form-checkbox>
                                        </div>
                                        <div class="form-group" v-if="invoice.SendInvoice==true">
                                            <label>{{$t('form.invoice.scheduledDeliveryDate')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="ScheduledInvoiceDeliveryDate"
                                                valueType="format" type="datetime" :format="datetimeFormat"
                                                :disabled="readOnlyDelivery" :popup-style="{ left: 0}"
                                                :append-to-body="false">
                                            </date-picker>
                                        </div>
                                        <div class="form-group" v-if="invoice.SendInvoice==true && invoice.Status==3">
                                            <label>{{$t('form.invoice.deliveryDate')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="invoice.SentAt"
                                                valueType="format" type="datetime" :format="datetimeFormat"
                                                disabled :popup-style="{left: 0}"
                                                :append-to-body="false">
                                            </date-picker>
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t('form.invoice.status')}}</label>
                                            <v-select @input="selectedStatus" :label="selected_status"
                                            v-model="selected_status" :options="statusArray" :reduce="statusArray => statusArray"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.invoice.tabAudit')">
                                <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                    :sort-desc="true" :current-page="currentPage" :fields="fields" small hover bordered
                                    responsive>
                                </b-table>

                                <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                    :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                </b-pagination>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        decimal
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'dateFormat', 'datetimeFormat', 'decimalDigits'],

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',
                updated:false,
                isLoading: false,
                fullPage: true,
                request_source: '',
                invalidCurrency: false,
                invalidDate: false,
                invalidInvoiceInfo: false,
                invalidDue: false,
                readOnlyDelivery: false,
                readOnlySend: false,
                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,
                disableAmount: false,
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,
                is_administrative:false,


                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                term:null,

                studentName: '',
                studentId: '',
                value: null,
                mbaCourseTitle: null,
                mbaCourseDate: moment().format(this.dateFormat),
                discount: 0,
                fullPaymentDiscount: 0,
                course: null,
                defaultAmount: null,
                newPurpose: null,
                InvoicePurpose:null,

                student:{
                    GlobalDiscount: 0
                },
                program: {
                    FullTitle: '',
                    AcademicYear: null,
                    AcceptanceFee: null,
                    ApplicationFee: null,
                    BillingCycle: null,
                    ID: null,
                    Major: null,
                    Notes: null,
                    PartnerCode: null,
                    ProgramCode: null,
                    ProgramTitle: null,
                    ProgramType: null,
                    Specialization: null,
                    TS: null,
                    TermFee: null,
                    TranscriptTitle: null,
                    pivot: null,
                    totalFee: null,
                },
                selected_course:null,
                ScheduledInvoiceDeliveryDate:null,
                paymentPlanReduction:true,
                invoice: {
                    StudentID: null,
                    InvoicePurpose: null,
                    InvoiceNumber: null,
                    InvoiceInfo: null,
                    Amount:0,
                    Discount:0,
                    DiscountedAmount:0,
                    AmountAfterDeductibles:0, /* Amount after transfer credit deductions */
                    FullPaymentDiscountedAmount:0,
                    Currency: null,
                    InvoiceDate: moment().format(this.dateFormat),
                    DueDate: null,
                    PaymentDate: null,
                    DeliveryDate: null,
                    SendInvoice: false,
                    Paid: false,
                    MailAddress: 1,
                    acceptanceFee: false,
                    Status: 'Pending',
                    SentAt:null,
                    CreatedBy:null,
                    PaymentPlanReductionLogic:false,
                    Version: null,
                    Remarks: null
                },
                selected_status: 'Pending',
                currencies: [],
                invoicePurposes: [],
                students: [],
                programs: [],
                courses: [],
                business: [],
                semesters: [],
                mbaCourse: [],
                audits: [],
                availableFormats: ['pdf', 'word'],
                timezone:'Europe/Zurich',
                status:null,
                statusArray:[],
                routeToMove:'StudentInvoiceIndex',
            }

        },

        validations: {
            invoice: {
                Amount: {
                    required,
                    decimal
                },
                Currency: {
                    required
                },
                InvoiceDate: {
                    required
                },
                DueDate: {
                    required
                },

            },
            studentName: {
                required
            },
            program: {
                    FullTitle:{required}
            }
        },
        // beforeRouteEnter (to, from, next) {
        //     next(vm => {
        //         var previous_path = from.name;
        //         if(previous_path== '/' || previous_path == null)
        //             vm.routeToMove = 'StudentInvoiceIndex';
        //         else
        //             vm.routeToMove = previous_path;
        //     })
        // },
        async mounted() {
            if (!this.permissions.viewInvoicesStudents) {
                return this.$router.push('/');
            }

            if (this.permissions.editInvoicesStudents) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }
            this.isLoading = true;

            await this.getInitialData();
            await this.getPrograms();
            await this.getStatusAndTimeZone();
            await this.getInvoice();
            await this.getCourses();
            this.closing = true;
        },

        computed: {
            isRadioDisabled() {
            return !(this.business.CompanyName && this.business.StreetAddress && this.business.City && this.business.Zip && this.business.Email);
            },
            businessTooltip() {
            if (!(this.business.CompanyName && this.business.StreetAddress && this.business.City && this.business.Zip && this.business.Email)) {
                return 'Student has no business address specified.';
                } else {
                    return '';
                }
            },

            InvoiceDeliveryDate(){

            var InvoiceDeliveryDate = this.invoice.DeliveryDate?(moment(this.invoice.DeliveryDate, this.datetimeFormat,true).isValid()?this.invoice.DeliveryDate:moment(this.invoice.DeliveryDate).format(this.datetimeFormat)):this.ScheduledInvoiceDeliveryDate
            return InvoiceDeliveryDate;
            },

            totalAudits() {
                return this.audits.length
            },

            readonly() {
                return !this.permissions.editInvoicesStudents;
            }
        },

        watch: {
            invoice: {
                handler(val){
                    this.closing = false;

                    if(val.SendInvoice == 0 || val.SendInvoice == false || val.SendInvoice == null || val.SendInvoice == undefined){
                      this.emptyDeliveryDate();
                    }else {
                        this.ScheduledInvoiceDeliveryDate = this.ScheduledInvoiceDeliveryDate?this.ScheduledInvoiceDeliveryDate:this.invoice.DeliveryDate?(this.invoice.DeliveryDate?moment(this.invoice.DeliveryDate).format(this.datetimeFormat):null):null;
                    }
                },
                deep: true
            },
            newPurpose: {
                handler(val){
                    this.closing = false;
                }
            },
            InvoicePurpose: {
                handler(val){
                    this.closing = false;
                }
            }
        },

        methods: {
            /* Remove formatting from Invoice Amount  */
            removeFormatting(amount)
            {
                return removeThousandSeparator(amount);

            },
            applyFormatting()
            {
                return toThousandSeparator(amount);
            },

            applyDiscount(e)
            {

                  if(e.code === 'Enter' || e.type === 'blur' || e === false)
                  {

                    if(this.student.GlobalDiscount > 0 && !this.invoice.applyPaymentPlanReduction)
                    {
                        const amount = removeThousandSeparator(this.invoice.Amount);
                        const discountedAmount = amount -  ( amount * this.student.GlobalDiscount / 100 );
                        this.invoice.DiscountedAmount = toThousandSeparator(discountedAmount);
                        this.invoice.Discount = this.student.GlobalDiscount;
                    }

                        this.invoice.Amount = toThousandSeparator(this.invoice.Amount);

                  }




            },

            emptyDeliveryDate(){
            this.ScheduledInvoiceDeliveryDate = null
            },

            getDate(date){
                var dateVar  = date?date:moment().format(this.datetimeFormat)
                return dateVar;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-attachment');
                if (token == '') return;

                window.open(`/invoices/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async getStatusAndTimeZone() {
                try{
                var self = this;
                const response = await axios.get('/api/config');
                if (response.data) {
                    let config = response.data;
                    self.status = config.status;
                    self.timezone = config.timezone;
                    if (( typeof self.status == 'object') && (self.status != '')) {
                            self.statusArray = Object.keys(self.status);
                    }
                }
                }catch(error){
                    console.log('error in fetching config values');
                    this.isLoading = false;
                };
            },

            getInitialData() {
                this.isLoading = true;

                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.defaultAmount = response.data.amount;
                        this.invoicePurposes = response.data.invoice_purposes;
                        this.currencies = response.data.currencies;
                        this.perPageAudits = response.data.auditsPaginate;


                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getPrograms() {
                axios
                    .get("/api/programs?full")
                    .then(response => {
                        this.programs = response.data;
                        this.programs.map(p => p.FullTitle = this.$options.filters.program(p));
                    })
                    .catch(error => console.log('error fetching programs'));
            },

            programSelected() {
                if (!this.program) {
                    this.program= {
                    FullTitle: '',
                    AcademicYear: null,
                    AcceptanceFee: null,
                    ApplicationFee: null,
                    BillingCycle: null,
                    ID: null,
                    Major: null,
                    Notes: null,
                    PartnerCode: null,
                    ProgramCode: null,
                    ProgramTitle: null,
                    ProgramType: null,
                    Specialization: null,
                    TS: null,
                    TermFee: null,
                    TranscriptTitle: null,
                    pivot: null,
                    totalFee: null,
                },
                    this.invoice.Amount = this.defaultAmount;
                    this.course = null;
                    return;
                }
                // this.getCourses();
            },

            async getCourses() {
                try{
                this.isLoading = true;

                var response = await axios.get(`/api/programs/${this.program.ID}/courses`)
                if(response.data){
                    var self = this;
                    if (response.data.length) {
                        this.courses = response.data;
                        this.courses.map(c => {
                            c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`;
                            c.Semester = c.pivot.Semester;
                            c.Fee = c.pivot.Fee;
                            if(self.selected_course){
                                if(c.ID == self.selected_course.ID){
                                    self.course = c
                                }
                            }
                        })

                        this.fetchSemesters();
                    }
                        this.isLoading = false;
                    }
                }catch(error){
                        console.log('error in fetching courses');
                        this.isLoading = false;
                };
            },

            selectedCourse(course) {
                if (!course) {
                    this.invoice.InvoicePurpose = null;
                    this.invoice.Amount = toThousandSeparator(this.defaultAmount);
                    return;
                }

                // set amount
                if (course.Fee && course.Fee > 0)
                    this.invoice.Amount = toThousandSeparator(course.Fee);

                // set invoice purpose for selected course
                let purpose = this.$t('form.invoice.coursePurpose', {
                    course: course.CourseTitle,
                    program: this.program.ProgramTitle
                });

                // if (!this.invoicePurposes.includes(purpose)) {
                //     this.invoicePurposes.unshift(purpose);
                // }

                this.InvoicePurpose = purpose;
            },

            selectedStatus(selected_status){
                this.invoice.Status = selected_status;
            },

            fetchSemesters() {
                let semesters = [];

                this.courses.forEach(c => {
                    let s = parseInt(c.Semester);
                    if (s) semesters.push(s);
                });

                this.semesters = [...new Set(semesters)].sort();
            },

            selectedSemester(semester) {

                if (!semester) {
                    this.invoice.InvoicePurpose = null;
                    this.invoice.Amount = this.defaultAmount;
                    return;
                }

                // set amount
                if (this.program.TermFee[semester - 1] && this.program.TermFee[semester - 1] > 0)
                    this.invoice.Amount = toThousandSeparator(this.program.TermFee[semester - 1]);

                // set invoice purpose for selected course
                let purpose = this.$t('form.invoice.termPurpose', {
                    semester: semester,
                    program: this.program.ProgramTitle
                });

                // if (!this.invoicePurposes.includes(purpose)) {
                //     this.invoicePurposes.unshift(purpose);
                // }

                this.InvoicePurpose = purpose;
            },

            invoicePaid() {
                if (this.invoice.Paid) {
                    this.invoice.PaymentDate = moment().format(this.dateFormat);
                    this.selected_status = Object.keys(this.status).find(key => this.status[key] === this.status["Paid"]);
                }else{
                    if(this.invoice.Status == 4){
                    this.selected_status = Object.keys(this.status).find(key => this.status[key] === 1);
                    }else{
                    this.selected_status = Object.keys(this.status).find(key => this.status[key] === this.invoice.Status);
                  }
               }
            },

            addPurpose() {
                if (!this.newPurpose) {
                    return;
                }

                if (!this.invoicePurposes.includes(this.newPurpose)) {
                    this.invoicePurposes.unshift(this.newPurpose);
                    this.savePurpose();
                }

                this.InvoicePurpose = this.newPurpose;
                this.closing = false;
                this.newPurpose = null;
            },
            convertTZ(date, timezone)
            {
                var s = date.toLocaleString(undefined, { timeZone: this.timezone })
                if(typeof s == "string"){
                    s = new Date(s)
                }
                var formatteddate = moment(s).format(this.datetimeFormat)
                return formatteddate;
            },
            savePurpose()
            {
                axios
                    .post("/api/settings?name=invoice-purposes", {
                        value: this.invoicePurposes
                    })
                    .then(response => {})
                    .catch(error => {});
            },

            async getInvoice()
            {
                try{
                const response = await axios.get(`/api/invoices/${this.$route.params.id}/edit`);
                    if(response.data)
                    {
                        /* Create a copy of object */
                        Object.assign(this.invoice, response.data.invoice);
                        this.audits =  response.data.audits;
                        this.invoice.SentAt = this.invoice.SentAt ? moment(this.invoice.SentAt).format(this.datetimeFormat) : null;
                        const purpose = this.invoice.InvoicePurpose.toLowerCase();
                        this.is_administrative = purpose.includes('administration');
                        this.invoice.excludeScholarshipReduction = this.invoice.excludeScholarshipReduction == 1;

                        this.ScheduledInvoiceDeliveryDate = this.invoice.DeliveryDate;
                        this.invoice.SendInvoice = this.invoice.SendInvoice !== 0;


                        this.newPurpose = this.invoice.InvoicePurpose == null ? '' : this.invoice
                            .InvoicePurpose;

                        if(this.status)
                        {
                        this.invoice.Status = this.invoice.Status ? this.invoice.Status : 1;
                        this.selected_status = Object.keys(this.status).find(key => this.status[key] === this.invoice.Status);
                        }

                        if (this.invoice.InvoiceDate)
                        {
                            this.invoice.InvoiceDate = moment(this.invoice.InvoiceDate).format(this.dateFormat);
                        }

                        if (this.invoice.DueDate)
                        {
                            this.invoice.DueDate = moment(this.invoice.DueDate).format(this.dateFormat);
                        }

                        if (this.invoice.PaymentDate)
                        {
                            this.invoice.PaymentDate = moment(this.invoice.PaymentDate).format(this.dateFormat);
                        }

                        if (this.ScheduledInvoiceDeliveryDate)
                        {
                            this.ScheduledInvoiceDeliveryDate = moment(this.ScheduledInvoiceDeliveryDate).format(this
                                .datetimeFormat);

                            const date = this.convertTZ(new Date(), this.timezone);

                            if((this.ScheduledInvoiceDeliveryDate <= date) && this.invoice.Status == 3)
                            {
                                if (this.invoice.SendInvoice)
                                {
                                    this.readOnlySend = true;
                                }

                                this.readOnlyDelivery = true;
                            }
                        }


                        const condition1 = this.invoice.CreatedBy === 'PaymentPlan' && this.invoice.Discount > 0 && this.invoice.ReductionLogic === 'PaymentPlan';
                        const condition2 = this.invoice.PaymentPlan === 'by Course/Semester/Term' && this.invoice.AmountAfterDeductibles !== null;
                         const condition3 = this.invoice.PaymentPlan === 'by Course/Semester/Term' && this.invoice.Discount > 0;


                        /* Disable conditions*/
                        if(condition1 || condition2 || condition3 || this.invoice.PaymentPlan === 'Full Payment')
                        {
                            this.disableAmount = true;
                        }

                        /* Apply Formating */
                        this.invoice.Amount = toThousandSeparator(this.invoice.Amount);
                        this.invoice.DiscountedAmount = toThousandSeparator(this.invoice.DiscountedAmount);
                        this.invoice.FullPaymentDiscountedAmount = toThousandSeparator(this.invoice.FullPaymentDiscountedAmount);
                        if(this.invoice.AmountAfterDeductibles && this.invoice.AmountAfterDeductibles> 0)
                        {
                            this.invoice.AmountAfterDeductibles = toThousandSeparator(this.invoice.AmountAfterDeductibles);
                        }

                        /* Student Business */
                        this.business = response.data.business;
                       
                        /* Student */
                        const student = response.data.student;
                        this.studentName = `${student.StudentNumber} - ${student.FirstName} ${student.LastName}`;
                        this.student.GlobalDiscount = student.GlobalDiscount;
                        this.fullPaymentDiscount =  student.FullPaymentDiscount;
                        this.invoice.StudentID = student.StudentID;
                        this.invoice.MailAddress = this.invoice.MailAddress ? this.invoice.MailAddress : (student.MailAddress ?student.MailAddress : 1);

                        /* Student Program */
                        this.program = response.data.program;
                        this.program.FullTitle = this.$options.filters.program(this.program);


                        /* Scholarship reduction logic checkbox */
                        this.term = this.invoice.Installment;

                        /* Courses  */
                        if(this.invoice.invoice_non_deductible_course.length > 0)
                        {
                            this.selected_course = this.invoice.invoice_non_deductible_course[0].course
                        }
                        else if(this.invoice.invoice_course.length > 0)
                        {
                            this.selected_course = this.invoice.invoice_course[0].course
                        }

                        this.audits.map(audit => {
                            if(audit.field == 'Status'){
                            var newValue = Object.keys(this.status).find(key => this.status[key] == audit.newValue);
                            audit.newValue = newValue;
                            var oldValue = Object.keys(this.status).find(key => this.status[key] == audit.oldValue);
                            audit.oldValue = oldValue;
                            }
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });

                        this.isLoading = false;
                        this.closing = true;
                    }


                }
                catch(error)
                {
                   // this.isLoading = false;
                    console.log(error);
                }
            },

            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {
                        this.sessionCreated = true;
                        if (response.data.warning == 0) {
                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },

            /**
             * Show Warning
             * Remove read-only from amount field
             * Deduct scholarship percentage directly from invoice amount (default logic)
             * Show checkbox "Exclude from scholarship reduction"
             */
            applyPaymentPlanReduction(){

                if(this.invoice.PaymentPlanReductionLogic == true){
                    if(confirm(this.$t('form.invoice.warning_apply_payment_plan_reduction'))){
                        this.invoice.PaymentPlanReductionLogic = false;
                        this.applyDiscount(true);

                    }
                }


            },
            // mbaCoursePurpose() {
            //     if (this.mbaCourseTitle && this.mbaCourseDate) {
            //         let purpose = this.$t('form.invoice.customPurpose', {
            //             title: this.mbaCourseTitle,
            //             date: moment(this.mbaCourseDate).format('MMMM YYYY')
            //         });

            //         this.invoicePurposes.unshift(purpose);
            //         this.invoice.InvoicePurpose = purpose;

            //         return purpose;
            //     }
            // },

            // setMBACourseTitle(ProgramTitle) {
            //     this.mbaCourseTitle = ProgramTitle;
            // },

            clear() {
                alert(this.$t('form.validation.cannotAllowed'));
            },

            updateInvoice(shouldClose = false) {
                this.$v.$touch();

                if (this.disableEditForm) return;
                if (shouldClose) {
                localStorage.setItem('from', 'UpdateAndCloseClicked');
                } else {
                  //  localStorage.removeItem('from');
                }// localStorage.setItem('from',"UpdateAndCloseClicked");
                this.invalidCurrency = this.invoice.Currency == null ? true : false;
                if(this.newPurpose == '')
                this.newPurpose = null;
                if(this.InvoicePurpose == '')
                this.InvoicePurpose = null;

                this.invoice.Amount = removeThousandSeparator(this.invoice.Amount);
                this.invoice.DiscountedAmount = removeThousandSeparator(this.invoice.DiscountedAmount);
                this.invoice.FullPaymentDiscountedAmount = removeThousandSeparator(this.invoice.FullPaymentDiscountedAmount);

                if(this.AmountAfterDeductibles === 0)
                {
                    this.invoice.AmountAfterDeductibles = 0
                }
                else if(this.AmountAfterDeductibles)
                {
                    this.invoice.AmountAfterDeductibles = removeThousandSeparator(this.AmountAfterDeductibles)
                }

                if (this.$v.$invalid || (this.InvoicePurpose == null && this.newPurpose == null)) {
                   let errorMsg = '';

                    if(this.$v.invoice.InvoiceInfo.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.InvoiceInfo'): this.$t('form.invoice.InvoiceInfo');
                    };

                    if(this.$v.invoice.Amount.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.amount'): this.$t('form.invoice.amount');
                    };

                    if(this.$v.invoice.Currency.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.currency'): this.$t('form.invoice.currency');
                    };

                    if(this.$v.invoice.InvoiceDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoiceDate'): this.$t('form.invoice.invoiceDate');
                    };

                    if(this.$v.invoice.DueDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.dueDate'):this.$t('form.invoice.dueDate');
                    };

                    if(this.$v.studentName.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.student'): this.$t('form.invoice.student');
                    };

                    if(this.$v.program.FullTitle.$error){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.program'):this.$t('form.invoice.program');
                    };

                    if(this.InvoicePurpose == null && this.newPurpose == null){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.invoicePurpose'):this.$t('form.invoice.invoicePurpose');
                    }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }
                if(this.newPurpose && this.InvoicePurpose){
                    if(confirm(this.$t('form.invoice.purposeOverwrittenWarning'))){

                    this.invoice.InvoicePurpose = this.InvoicePurpose ? this.InvoicePurpose :this.newPurpose;
                    this.newPurpose = null;

                    }else{

                        return;

                    }
                }else{
                    this.invoice.InvoicePurpose = this.InvoicePurpose ? this.InvoicePurpose :this.newPurpose;
                }
                this.isLoading = true;
                this.invoice.Status = this.selected_status;

                // this.invoice.SendInvoice = this.invoice.SendInvoice?1:0;
                this.invoice.DeliveryDate = this.ScheduledInvoiceDeliveryDate;
                if (this.selected_status)
                this.invoice.Status = this.selected_status;
                if(this.course)
                {
                this.invoice.course = this.course;
                }

                this.invoice.Installment = this.term;


                axios
                    .put('/api/invoices/' + this.$route.params.id, this.invoice)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);this.updated = true;
                               if (shouldClose) {
                                   clearInterval(this.interval);
                                    setTimeout(() => {
                                        window.history.length >= 3 ? this.$router.go(-1):
                                    this.$router.push({
                                        name: this.routeToMove
                                    }).catch(()=>{});
                                }, 2000);
                                    return;
                                }

                                this.closing = true;
                        }

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getDueDate(days, format = 'YYYY-MM-DD') {
                days = parseInt(days);
                return moment().add(days, 'days').format(format);
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing || this.updated){
                next();
            }else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next();
                } else {
                    next(false);
                }
            }
        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }
</style>
